import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { RouterBaseService } from '@tdwb/core';

import { DividerComponent } from '../../../components/panel/divider.component';
import { ModalCloseReason } from '../../../components/modal/modal.domain';
import { ButtonComponent } from '../../../components/button/button.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { PageActionPanelComponent } from '../../../features/page/page-action-panel.component';
import { NotificationComponent } from '../../../components/notification/notification.component';
import { ModalCloseDirective } from '../../../components/modal/components/modal-close/modal-close-button.directive';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { W8BenModalName, W8BenTaggingFlowType } from '../w8ben-form.domain';
import { W8benFormAnalytics } from '../w8ben-form.analytics';

@Component({
  selector: 'td-wb-w8ben-special-tax-benefits',
  templateUrl: './w8ben-form-special-tax-benefits.component.html',
  styleUrls: ['./w8ben-form-special-tax-benefits.component.scss'],
  imports: [
    NotificationComponent,
    IconComponent,
    DividerComponent,
    PageActionPanelComponent,
    ButtonComponent,
    ModalCloseDirective,
    TranslatePipe,
    TranslateDirective,
    HrefDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class W8benFormSpecialTaxBenefitsComponent implements OnInit {
  protected modalCloseReason: ModalCloseReason = ModalCloseReason.ESC;
  protected flow: W8BenTaggingFlowType;

  @Input() hasUpdates: boolean = false;

  constructor(private routerService: RouterBaseService,
              private w8benFormAnalyticsService: W8BenFormAnalyticsService) {}

  ngOnInit(): void {
    this.flow = this.hasUpdates ? 'd' : 'b';
    this.w8benFormAnalyticsService.setTaggingData(W8BenModalName.SPECIAL_RATE_CONDITION, this.flow);
    this.w8benFormAnalyticsService.emitPageChange(W8benFormAnalytics.getModalEvent(W8BenModalName.SPECIAL_RATE_CONDITION, this.flow, 'complete'));
  }

  protected getModalId(): string {
    return this.w8benFormAnalyticsService.getModalId();
  }

  onBackClick(): void {
    this.routerService.go('modal.w8ben.tax_residency_benefits', { hasUpdates: this.hasUpdates });
  }
}

